module.exports = __webpack_public_path__ + "static/media/music-alt.a4ed4201.svg";